import { Button } from '@components/Button';
import { IconAdd, IconLogout, IconArrowForward } from '@components/icons';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const ButtonsSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="Buttons"
      description="Buttons are used for actions. They come in three variants and three sizes."
      figmaNodeId="5-6"
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Primary Buttons</h3>
      <div className={styles.row}>
        <Button variant="primary" size="large">
          Large
        </Button>
        <Button variant="primary" size="regular">
          Regular
        </Button>
        <Button variant="primary" size="small">
          Small
        </Button>
        <Button variant="primary" size="regular" disabled>
          Disabled
        </Button>
        <Button variant="primary" size="large" leadingIcon={<IconAdd size={20} />}>
          With Icon
        </Button>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Secondary Buttons</h3>
      <div className={styles.row}>
        <Button variant="secondary" size="large">
          Large
        </Button>
        <Button variant="secondary" size="regular">
          Regular
        </Button>
        <Button variant="secondary" size="small">
          Small
        </Button>
        <Button variant="secondary" size="regular" disabled>
          Disabled
        </Button>
        <Button variant="secondary" size="large" leadingIcon={<IconLogout size={20} />}>
          Logout
        </Button>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Text Buttons</h3>
      <div className={styles.row}>
        <Button variant="text" size="large">
          Large
        </Button>
        <Button variant="text" size="regular">
          Regular
        </Button>
        <Button variant="text" size="small">
          Small
        </Button>
        <Button variant="text" size="regular" disabled>
          Disabled
        </Button>
        <Button variant="text" size="large" trailingIcon={<IconArrowForward size={20} />}>
          Learn More
        </Button>
      </div>
    </div>
  </section>
);
